// EtiquetasRoutesXL - S47.1.
// Rutas del modulo Etiquetas XL. Por ahora una unica vista (editor).
// S47.2/S47.3 podran agregar listado de plantillas y vista de impresion.
import { Routes, Route } from 'react-router-dom';
import EtiquetasPageXL from './EtiquetasPageXL';

export default function EtiquetasRoutesXL() {
  return (
    <Routes>
      <Route index element={<EtiquetasPageXL />} />
    </Routes>
  );
}
